// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container__73eXt","loading":"List_loading__Ude3G","list":"List_list__uDX67","listItem":"List_listItem__JwjTl"};